/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceAddressSnapshot
 */
export interface InvoiceAddressSnapshot {
    /**
     * 
     * @type {string}
     * @memberof InvoiceAddressSnapshot
     */
    addressLine1: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceAddressSnapshot
     */
    addressLine2: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceAddressSnapshot
     */
    addressLine3: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceAddressSnapshot
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceAddressSnapshot
     */
    state: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceAddressSnapshot
     */
    zip: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceAddressSnapshot
     */
    country: string | null;
}

/**
 * Check if a given object implements the InvoiceAddressSnapshot interface.
 */
export function instanceOfInvoiceAddressSnapshot(value: object): value is InvoiceAddressSnapshot {
    if (!('addressLine1' in value) || value['addressLine1'] === undefined) return false;
    if (!('addressLine2' in value) || value['addressLine2'] === undefined) return false;
    if (!('addressLine3' in value) || value['addressLine3'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function InvoiceAddressSnapshotFromJSON(json: any): InvoiceAddressSnapshot {
    return InvoiceAddressSnapshotFromJSONTyped(json, false);
}

export function InvoiceAddressSnapshotFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceAddressSnapshot {
    if (json == null) {
        return json;
    }
    return {
        
        'addressLine1': json['addressLine1'],
        'addressLine2': json['addressLine2'],
        'addressLine3': json['addressLine3'],
        'city': json['city'],
        'state': json['state'],
        'zip': json['zip'],
        'country': json['country'],
    };
}

export function InvoiceAddressSnapshotToJSON(json: any): InvoiceAddressSnapshot {
    return InvoiceAddressSnapshotToJSONTyped(json, false);
}

export function InvoiceAddressSnapshotToJSONTyped(value?: InvoiceAddressSnapshot | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'addressLine3': value['addressLine3'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'country': value['country'],
    };
}

